'use strict';

const moment = require('moment');
const BasePresenter = require('./base');

class TimePresenter extends BasePresenter {
  constructor() {
    super(...arguments);
    this.setModule('glive_booking_redesign');
  }

  timeHash(timeModel) {
    const momentTime = moment(timeModel.toString(), 'h:mm');
    if (momentTime.isValid()) {
      return {
        hours: momentTime.format('hh'),
        minutes: momentTime.format('mm'),
        period: momentTime.format('A'),
        isDateTime: true,
      };
    } else {
      return {
        time: timeModel.toString(),
        isDateTime: false,
      };
    }
  }

  modelToHash(model, selection) {
    const timeHash = this.timeHash(model);
    const selected = (selection && selection.isEqual(model)) || false;
    const time = { timeHash, selected };
    return { time };
  }

  toHash() {
    if (this.model != null) {
      return this.modelToHash(this.model, this.options ? this.options.selected : undefined);
    } else {
      return false;
    }
  }
}

module.exports = TimePresenter;
